module.exports = {
      id: "ps-size-large-usage",
      viewBox: "0 0 500 500",
      url: __webpack_public_path__ + "images/sprites.min-761fd8cda42a160ac5ce8fc99730232c.svg#ps-size-large-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./client/src/site__scf001/components/site/sprites/ps-size-large.svg
// module id = /home/vsts/work/1/s/src/SCF/node_modules/svg-sprite-loader/lib/loader.js??ref--12-0!/home/vsts/work/1/s/src/SCF/client/src/site__scf001/components/site/sprites/ps-size-large.svg
// module chunks = site__scf001